interface Props {
  className?: string;
}
const Delete = (props: Props) => (
  <svg
    fill="none"
    height="13"
    viewBox="0 0 12 13"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.36364 1.625H7.63636V0.677083C7.63636 0.641333 7.62218 0.606667 7.59655 0.581208C7.57091 0.55575 7.536 0.541667 7.5 0.541667H4.5C4.464 0.541667 4.42909 0.55575 4.40345 0.581208C4.37782 0.606667 4.36364 0.641333 4.36364 0.677083V1.625ZM10.3636 2.16667H1.63636V11.9167C1.63636 12.2157 1.88073 12.4583 2.18182 12.4583H9.81818C10.1193 12.4583 10.3636 12.2157 10.3636 11.9167V2.16667ZM4.90909 4.0625C4.90909 3.913 4.78691 3.79167 4.63636 3.79167C4.48582 3.79167 4.36364 3.913 4.36364 4.0625V10.5625C4.36364 10.712 4.48582 10.8333 4.63636 10.8333C4.78691 10.8333 4.90909 10.712 4.90909 10.5625V4.0625ZM7.63636 4.0625C7.63636 3.913 7.51418 3.79167 7.36364 3.79167C7.21309 3.79167 7.09091 3.913 7.09091 4.0625V10.5625C7.09091 10.712 7.21309 10.8333 7.36364 10.8333C7.51418 10.8333 7.63636 10.712 7.63636 10.5625V4.0625ZM12 1.625V2.16667H10.9091V11.9167C10.9091 12.5152 10.4209 13 9.81818 13H2.18182C1.57909 13 1.09091 12.5152 1.09091 11.9167V2.16667H0V1.625H3.81818V0.541667C3.81818 0.242667 4.06255 0 4.36364 0H7.63636C7.93745 0 8.18182 0.242667 8.18182 0.541667V1.625H12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Delete;
